import { Component, OnInit } from "@angular/core";
import { EngagementModel } from "../../../models/engagement.model";
import { EngagementService } from "../../../services/engagement.service";
import { ActivatedRoute, Router } from "@angular/router";
import { MessageService } from "primeng/api";
import { ConfirmationService } from "primeng/api";
import { Sharedservice } from "../../../shared-components/shared.service";
import { CoverIndexService } from "../../../services/coverindex.service";
import {
  severitymessage,
  LanguageConstants,
} from "../../../shared-components/constant";
import { environment } from "src/environments/environment";
import { InfraService } from "src/app/services/infra.service";
import { RegionsEnum } from "./../../../enums/regions.enum";
import moment from "moment";
import { AccountingCalendarEnum } from "src/app/enums/accounting-calendar.enum";
import { AuditingService } from "../../../services/auditing.service";
import { saveAs } from "file-saver";
import { TranslateService, LangChangeEvent } from "@ngx-translate/core";
import { LanguageHelperService } from "src/app/services/language.helper.service";
import { AppConfigurationService } from "../../../services/appConfiguration.service";
import { AppConfigurationsModel } from "../../../models/appConfigurations.model";
import { Observable } from "rxjs";
import { PbiWorkSpaceModel } from "../../../models/pbiWorkSpace.model";
import { PbiWorkSpaceService } from "src/app/services/pbiworkspace.service";
import { UserModel } from "../../../models/user.model";
import { UserService } from "./../../../services/user.service";
import { CountryService } from "src/app/services/country.service";
import { RegionService } from "src/app/services/region.service";
import { ChangeDetectorRef } from "@angular/core";
@Component({
  standalone: false,
  selector: "app-viewsingleengagement",
  templateUrl: "./view-singleengagement.component.html",
  styleUrls: ["./view-singleengagement.component.css"],
})
export class ViewSingleEngagementComponent implements OnInit {
  private EnvName = environment.ENV;
  public engagement: EngagementModel;
  public pbiWorkSpace: PbiWorkSpaceModel = new PbiWorkSpaceModel();
  //public pbiWorkSpaceUser: PbiWorkSpaceUserModel = new PbiWorkSpaceUserModel();
  public closedClicked = false;
  public status: string;
  public disableonstatus = false;
  public WBstatus=null;
  isEngagementReadOnly: boolean = false;
  engId: number;
  countryId:string;
  isDatabookExist: boolean;
  public isCurrencyOrFiscalMonthNull = false;
  public processorVersion: string = environment.processorVersion;
  public selectedregion = null;
  public selectedCountry = null;
  public selectedTemplate = null;
  private regionName = "";
  loggedInUserId: number;
  public firstDateOfFiscalYear: string;
  accountingCalendar = "";
  public isFirstDateOfFiscalYearShow = false;
  public isAccountingCalendarId = false;
  countryFlagClass = "";
  public loadspinner = false;
  firstInstanceofFifthYear;
  langCode: string;
  currLangTranslation: any;
  private pbiRegion: any;
  userEmail: string = "";
  display: boolean = false;
  isAssessmentDisabled: boolean = false;

  private loggedInUserData: UserModel[];
  constructor(
    private infraService: InfraService,
    private engagementService: EngagementService,
    private route: ActivatedRoute,
    private messageService: MessageService,
    private router: Router,
    private confirmationService: ConfirmationService,
    public sharedService: Sharedservice,
    private coverIndexService: CoverIndexService,
    private auditingService: AuditingService,
    private translateService: TranslateService,
    private appConfigService: AppConfigurationService,
    private pbiworkspaceService: PbiWorkSpaceService,
    private languageHelper: LanguageHelperService,
    private userService: UserService,
    private countryService : CountryService,
    private regionService : RegionService,
    private changeDetectorRef: ChangeDetectorRef
  ) {
    this.countryId = this.route.snapshot.paramMap.get('countryId');
    console.log(this.countryId,'WBCountryId in view engagement');
    this.infraService.infraDetails$.subscribe((data) => {
      if (data !== undefined) {
        this.selectedregion = data.InfraId;
        this.selectedCountry = data.CountryId;
        this.selectedTemplate = data.TemplateId;
        this.regionName = data.RegionName;
      }
    });

   
    this.engId = +this.route.snapshot.paramMap.get("id");
    this.isEngagementReadOnly =
      this.appConfigService.GetConfigValueByKey("IsProjectsReadOnly");

    this.userService.cast.subscribe((userData: UserModel) => {
      if (userData !== undefined && Object.keys(userData).length !== 0) {
        this.loggedInUserData = [];
        this.loggedInUserData.push(userData);
      }
      if (this.loggedInUserData && this.loggedInUserData.length > 0) {
        const event = {
          query: this.loggedInUserData[0].FamilyName,
        };
        //this.searchUsers(event);
      }
    });
  }

  ngOnInit() {

    //this.g
    if(this.countryId != undefined && this.countryId != "null"){
      var region='';
      this.countryService.getcountrylist().subscribe((response: any[]) => {
        var infraId = response.filter(x=> x.Id == this.countryId)[0].InfraId;
        //console.log(infraId,'infra id');
        this.selectedregion = infraId;
        this.selectedCountry = this.countryId;
        var selectedInfra =  this.countryId + ", 0 , "+ this.selectedregion;
        //console.log(selectedInfra,'selectedInfra in view single engagement');
        localStorage.setItem('selectedInfra', selectedInfra);

        // this.regionService.getRegions().subscribe(data => {
        //   const regionData = data.find(x => x.Id === this.selectedregion);
        //   region = regionData.Name;
        //   this.infraService.setRegion(region);
        // });

        this.infraService.setInfraDetails(selectedInfra);
      });
    }
    this.messageService.clear("myKey1");
    this.langCode = localStorage.getItem(LanguageConstants.LANG_CODE);
    this.currLangTranslation =
      this.translateService.translations[this.langCode];
    this.translateService.onLangChange.subscribe(
      (langEvent: LangChangeEvent) => {
        this.currLangTranslation = langEvent.translations;
        this.langCode = langEvent.lang;

        if (this.countryId != undefined) {
          //console.log(this.countryId,'not equal to undefined');
          setTimeout(() => {
            console.log("in translation");
          this.getEngagement();
          },1000);
        }
        else {
         // console.log(this.countryId,'equal to undefined');
          this.CheckAccessAndGetEngagement();
        }   
      }
    );
    //this.getProjectTeam();

    if (this.countryId != undefined) {
      console.log("Country check undefine");
       this.infraService.infraDetails$.subscribe(async res => {
         var coCheck: number = +this.countryId;
         console.log(res.CountryId, "Country check before engagement call");
         var selectedInfra = res.CountryId + ", 0 , " + res.InfraId;
         //console.log(selectedInfra,'selectedInfra in view single engagement');
         localStorage.setItem('selectedInfra', selectedInfra);
        if (res.CountryId == coCheck)
          await this.getEngagement();
      });
    }
    else {
      this.CheckAccessAndGetEngagement();
    }

    //if (this.countryId != undefined) {
    //  //console.log(this.countryId,'not equal to undefined');
    //  setTimeout(() => {
    //    console.log("country undefined");
    //    this.getEngagement();
    //    },1000);
    //}
    //else {
    //  //console.log(this.countryId,'equal to undefined');
    //  this.CheckAccessAndGetEngagement();
    //}

    this.getUploadedSourceFiles();

    localStorage.removeItem('WBCountryId'); 
    localStorage.removeItem('WBEngagementId');

  }

  CheckAccessAndGetEngagement() {
    this.engagementService.CheckUserAccessForEngagement(this.engId).subscribe(
      (data) => {
        if (data === 1) {
         // console.log(this.countryId,'getEngagement');
          console.log("check access");
          this.getEngagement();
        } else if (data === 0) {

          this.router.navigate(["unauthorize"], {
            queryParams: { redirectFrom: "engagement" },
          });
        }
      },
      (error) => {
        if (error.status === 401) {
          //console.log(this.countryId,'401');
          this.router.navigate(["unauthorize"], {
            queryParams: { redirectFrom: "engagement" },
          });
        }
      }
    );
  }

  getProjectTeam() {
    this.engagementService
      .getEngagementUsers(this.engId)
      .subscribe((userData: UserModel[]) => {
        this.engagement.UserNames = userData;

        for (let i = 0; i < userData.length; i++) {
          if (i === 0) this.userEmail = userData[i].UPN;
          else this.userEmail = this.userEmail + "," + userData[i].UPN;
        }
      });
  }
  private getEngagement(): void {
    console.log("in view single engagement call");
    this.engagementService
      .getEngagement(this.engId)
      .subscribe((data: EngagementModel) => {
        this.getDatabookstatus(data.IsDynamicDatabook);
        this.engagementService.engModel = data;
        //this.engagementService.isPnp = data.IsPnP;
        this.engagement = data;
        this.engagement.FiscalYearMonthName =
          this.languageHelper.convertMonthToLocale(
            this.langCode,
            this.engagement.FiscalYearMonthName
          );
        if (
          this.engagement.CountryCode !== undefined &&
          this.engagement.CountryCode !== null
        ) {
          this.countryFlagClass =
            "flag-icon-" + this.engagement.CountryCode.toLowerCase();
        }
        this.engagement.RegionName = this.regionName;
        this.isFirstDateOfFiscalYearShow = false;

        var calenderId = this.engagement.AccCalendarId.toString()
        localStorage.setItem(
          "CurrentAccountCalenderId" + this.engId,
          calenderId
        );
        localStorage.setItem(
          "TemplateId",
          this.engagement.TemplateId.toString()
        );
        localStorage.setItem(
          "IsCustomizedEngagement",
          this.engagement.IsCustomizedEngagement.toString()
        );
        if (
          this.engagement.AccCalendarId !== AccountingCalendarEnum.P12 &&
          this.engagement.AccCalendarId !== null &&
          this.engagement.AccCalendarId !== undefined &&
          this.engagement.AccCalendarId !== 0
        ) {
          this.isFirstDateOfFiscalYearShow = true;
          this.firstDateOfFiscalYear = moment(
            data.FirstDateOfFiscalYear
          ).format("DD/MM/YYYY");
          if (this.selectedregion === RegionsEnum.US) {
            this.firstDateOfFiscalYear = moment(
              data.FirstDateOfFiscalYear
            ).format("MM/DD/YYYY");
          }
          if (
            (this.engagement.AccCalendarId == AccountingCalendarEnum.P445 ||
              this.engagement.AccCalendarId ==
                AccountingCalendarEnum.P454 ||
              this.engagement.AccCalendarId ==
                AccountingCalendarEnum.P544) &&
            this.engagement.AccCalendarId !== null &&
            this.engagement.AccCalendarId !== undefined &&
            this.engagement.AccCalendarId > 0
          ) {
            this.firstInstanceofFifthYear = false;
          } else {
            this.firstInstanceofFifthYear = true;
          }
        }
        if (data.ReportingCurrencyId == null || data.FiscalYearMonth == null) {
          this.isCurrencyOrFiscalMonthNull = true;
        }
        if (
          this.engagement.AccCalendarId == null ||
          this.engagement.AccCalendarId == undefined ||
          this.engagement.AccCalendarId == 0
        ) {
          this.isAccountingCalendarId = true;
        }
        const status = data.Status;
        this.disableonstatus = !status;
        this.WBstatus=data.WBStatus;

        if (data.IsFlatfileTemplateUploaded) {
          localStorage.setItem(
            "isTempFlatfileUploaded" + this.engId + this.selectedregion,
            "1"
          );
        } else {
          localStorage.setItem(
            "isTempFlatfileUploaded" + this.engId + this.selectedregion,
            "0"
          );
        }

        this.engagementService.engModel = data;
        this.changeDetectorRef.detectChanges();
      });
      setTimeout(() => {
        this.getProjectTeam();
        },1000);
   
  }

  OpenLastTab(option) {
    if (!this.disableonstatus) {
      const isTempFlatfileUploaded = this.engagement.IsFlatfileTemplateUploaded;
      let stepid = this.engagement.StepId;
      const activeindex =
        +this.sharedService.getLocalStorageValueByName("activeindex");
      if (
        this.engagement.FlatFileStepID === 7 &&
        this.engagement.RedirectToVerification === 1
      ) {
        if (option === "assisted") {
          stepid = 5;
        } else {
          stepid = 2;
        }

        // update FlatFileStepID to 0
        const datatoupdate = {
          FlatFileStepId: 0,
        };
        this.engagementService
          .updateEngagementFlatFileStepId(
            this.engId,
            datatoupdate.FlatFileStepId
          )
          .subscribe();
      }

      if (option === "assisted") {
        localStorage.setItem(
          "generateDatabookViaTemplate" + this.engId + this.selectedregion,
          "0"
        );
        if (isTempFlatfileUploaded) {
          stepid = activeindex > 5 ? activeindex : 5;
        }
        if (stepid == null) {
          localStorage.setItem("activeindex", "0");
          this.router.navigate(["engagement/" + this.engId + "/uploadsource"]);
        } else {
          localStorage.setItem("activeindex", stepid.toString());
          switch (stepid) {
            case 0:
              this.router.navigate([
                "engagement/" + this.engId + "/uploadsource",
              ]);
              break;
            case 1:
              this.router.navigate([
                "engagement/" + this.engId + "/previewsourcefile",
              ]);
              break;
            case 2:
              this.router.navigate([
                "engagement/" + this.engId + "/inputcapture",
              ]);
              break;
            case 3:
              this.router.navigate(["engagement/" + this.engId + "/scenario"]);
              break;
            case 4:
              this.router.navigate([
                "engagement/" + this.engId + "/mappingselection",
              ]);
              break;
            case 5:
              this.router.navigate([
                "engagement/" + this.engId + "/remediation",
              ]);
              break;
            case 6:
              this.router.navigate([
                "engagement/" + this.engId + "/performdatacheck",
              ]);
              break;
            case 7:
              this.router.navigate(["engagement/" + this.engId + "/schedules"]);
              break;
            default:
              break;
          }
        }
      } else {
        if (stepid != null) {
          this.sharedService.setactiveindex(stepid);
        }
        if (!this.engagement.IsFlatfileTemplateUploaded && stepid > 0) {
          this.sharedService.setactiveindex(0);
          stepid = 0;
        }

        if (
          this.engagementService.engModel.IsPnP === true &&
          this.engagement.TemplateId != 3 && this.engagementService.engModel.AccCalendarId  === 1
        ) {
          switch (stepid) {
            case null:
              this.sharedService.setactiveindex(0);
              this.router.navigate([
                "engagement/" + this.engId + "/layout",
              ]);
              break;
            case 0:
              this.router.navigate([
                "engagement/" + this.engId + "/layout",
              ]);
              break;
            case 1:
              this.router.navigate([
                "engagement/" + this.engId + "/uploaddownloadflatfile",
              ]);
              break;
            case 2:
              this.router.navigate([
                "engagement/" + this.engId + "/mappingselection",
              ]);
              break;
            case 3:
              this.router.navigate([
                "engagement/" + this.engId + "/remediation",
              ]);
              break;
            case 4:
              this.router.navigate([
                "engagement/" + this.engId + "/performdatacheck",
              ]);
              break;
            case 5:
              this.router.navigate(["engagement/" + this.engId + "/schedules"]);
              break;
            default:
              break;
          }
        } else {
          switch (stepid) {
            case null:
              this.sharedService.setactiveindex(0);

              this.router.navigate([
                "engagement/" + this.engId + "/uploaddownloadflatfile",
              ]);

              break;

            case 0:
              //this.sharedService.setactiveindex(0);
              this.router.navigate([
                "engagement/" + this.engId + "/uploaddownloadflatfile",
              ]);

              break;

            case 1:
              this.router.navigate([
                "engagement/" + this.engId + "/mappingselection",
              ]);

              break;

            case 2:
              this.router.navigate([
                "engagement/" + this.engId + "/remediation",
              ]);

              break;

            case 3:
              this.router.navigate([
                "engagement/" + this.engId + "/performdatacheck",
              ]);

              break;

            case 4:
              this.router.navigate(["engagement/" + this.engId + "/schedules"]);

              break;

            default:
              break;
          }
        }
      }
    }
  }
  private setWorkSapceModel() {
    if (
      this.EnvName.toLowerCase() === "dev" ||
      this.EnvName.toLowerCase() === "local" ||
      this.EnvName.toLowerCase() === "azureeverest"
    ) {
      this.EnvName = "Development";
    } else if (this.EnvName.toLowerCase() === "qa") {
      this.EnvName = "QA";
    } else if (this.EnvName.toLowerCase() === "prod") {
      this.EnvName = "Production";
    } else if (this.EnvName.toLowerCase() === "uat") {
      this.EnvName = "UAT";
    }
    if (this.regionName.toUpperCase() === "US") {
      this.pbiRegion = "eastus";
    } else if (this.regionName.toUpperCase() === "EMEIA") {
      this.pbiRegion = "westeurope";
    } else if (this.regionName.toUpperCase() === "APAC") {
      this.pbiRegion = "australiaeast";
    }

    this.pbiWorkSpace = {
      environment: this.EnvName,
      location: this.pbiRegion,
      pbiworkspace: false,
      pbiworkspacedestroy: true,
      pbiworkspaceName: "Workspace_Engagement_" + this.engagement.Id,
      userEmails: this.userEmail,
      Access: "Contributor",
      addremove: "remove",
      workspaceName: "Workspace_Engagement_" + this.engagement.Id,
      requestedby: this.loggedInUserData[0].UPN,
    };
  }

  closeEngagement() {
    if (!(this.closedClicked || this.disableonstatus)) {
      this.display = true
      //this.confirmationService.confirm({
      //  message:
      //    this.currLangTranslation.viewSingleEngagementComponentmessage
      //      .ErrorMessage.ReversedError,
      //  acceptLabel: this.currLangTranslation.actionButtons.ClosePermanently,
      //  rejectLabel: this.currLangTranslation.actionButtons.MakeInactive,
      //  accept: () => {
      //    this.engagementService.deleteEngagement(this.engagement.Id, this.regionName).subscribe(
      //      (data) => {
      //        this.closedClicked = true;
      //        this.messageService.add({
      //          key: this.currLangTranslation.severitymessage.key2,
      //          severity: severitymessage.success,
      //          summary: this.currLangTranslation.severitymessage.notification,
      //          detail:
      //            this.currLangTranslation.viewSingleEngagementComponentmessage
      //              .SuccessMessage.ProjectClose,
      //          life: 10000,
      //        });
      //        // Commenting the triggerint point of PBI
      //        //this.setWorkSapceModel();
      //        //this.pbiworkspaceService.DeleteWorkSpaceQueue(this.pbiWorkSpace)
      //        //  .subscribe((data) => {
      //        //  });
      //        this.router.navigate(["engagement"]);
      //      },
      //      (error) => {
      //        this.closedClicked = false;
      //        this.messageService.add({
      //          key: this.currLangTranslation.severitymessage.key2,
      //          severity: severitymessage.error,
      //          summary: this.currLangTranslation.severitymessage.notification,
      //          detail:
      //            this.currLangTranslation.viewSingleEngagementComponentmessage
      //              .ErrorMessage.CloseProject,
      //          sticky: true,
      //          closable: true,
      //        });
      //      }
      //    );
      //  },
      //  reject: () => {
      //     this.engagementService.closeEngagement(this.engagement.Id).subscribe(
      //      (data) => {
      //        this.closedClicked = true;
      //        this.messageService.add({
      //          key: this.currLangTranslation.severitymessage.key2,
      //          severity: severitymessage.success,
      //          summary: this.currLangTranslation.severitymessage.notification,
      //          detail:
      //            this.currLangTranslation.viewSingleEngagementComponentmessage
      //              .SuccessMessage.ProjectClose,
      //          life: 10000,
      //        });
      //        // Commenting the triggerint point of PBI
      //        //this.setWorkSapceModel();
      //        //this.pbiworkspaceService.DeleteWorkSpaceQueue(this.pbiWorkSpace)
      //        //  .subscribe((data) => {
      //        //  });
      //        this.router.navigate(["engagement"]);
      //      },
      //      (error) => {
      //        this.closedClicked = false;
      //        this.messageService.add({
      //          key: this.currLangTranslation.severitymessage.key2,
      //          severity: severitymessage.error,
      //          summary: this.currLangTranslation.severitymessage.notification,
      //          detail:
      //            this.currLangTranslation.viewSingleEngagementComponentmessage
      //              .ErrorMessage.CloseProject,
      //          sticky: true,
      //          closable: true,
      //        });
      //      }
      //    );
      //    this.closedClicked = false;
      //  },
      //});
    }
  }

  confirm() {
    this.display = false;
    this.engagementService.deleteEngagement(this.engagement.Id, this.regionName).subscribe(
      (data) => {
        this.messageService.add({
          key: this.currLangTranslation.severitymessage.key2,
          severity: severitymessage.success,
          summary: this.currLangTranslation.severitymessage.notification,
          detail:
            this.currLangTranslation.viewSingleEngagementComponentmessage
              .SuccessMessage.ProjectClose,
          life: 10000,
        });
        // Commenting the triggerint point of PBI
        //this.setWorkSapceModel();
        //this.pbiworkspaceService.DeleteWorkSpaceQueue(this.pbiWorkSpace)
        //  .subscribe((data) => {
        //  });
        this.router.navigate(["engagement"]);
      },
      (error) => {
        this.closedClicked = false;
        this.messageService.add({
          key: this.currLangTranslation.severitymessage.key2,
          severity: severitymessage.error,
          summary: this.currLangTranslation.severitymessage.notification,
          detail:
            this.currLangTranslation.viewSingleEngagementComponentmessage
              .ErrorMessage.CloseProject,
          sticky: true,
          closable: true,
        });
      }
    );
  }

  reject() {
    this.display = false;
    this.engagementService.closeEngagement(this.engagement.Id).subscribe(
      (data) => {
        this.closedClicked = true;
        this.messageService.add({
          key: this.currLangTranslation.severitymessage.key2,
          severity: severitymessage.success,
          summary: this.currLangTranslation.severitymessage.notification,
          detail:
            this.currLangTranslation.viewSingleEngagementComponentmessage
              .SuccessMessage.ProjectClose,
          life: 10000,
        });
        // Commenting the triggerint point of PBI
        //this.setWorkSapceModel();
        //this.pbiworkspaceService.DeleteWorkSpaceQueue(this.pbiWorkSpace)
        //  .subscribe((data) => {
        //  });
        this.router.navigate(["engagement"]);
      },
      (error) => {
        this.closedClicked = false;
        this.messageService.add({
          key: this.currLangTranslation.severitymessage.key2,
          severity: severitymessage.error,
          summary: this.currLangTranslation.severitymessage.notification,
          detail:
            this.currLangTranslation.viewSingleEngagementComponentmessage
              .ErrorMessage.CloseProject,
          sticky: true,
          closable: true,
        });
      }
    );
    this.closedClicked = false;
  }

  cancel() {
    this.display = false;
  }

  getDatabookstatus(isDynamicDatabook: boolean) {
    this.coverIndexService
      .getDatabookstatus(this.engId, isDynamicDatabook)
      .subscribe((data: any[]) => {
        if (data.length >= 1) {
          this.isDatabookExist = true;
        } else {
          this.isDatabookExist = false;
        }
      });
  }

  editEngagement() {
    if (!this.disableonstatus) {
      this.router.navigate(["/editengagement", this.engagement.Id]);
    }
  }

  uploadDownloadFlatFile() {
    localStorage.setItem(
      "generateDatabookViaTemplate" + this.engId + this.selectedregion,
      "1"
    );
    this.OpenLastTab("flatFile");
  }

  downloadDatabook() {
    if (!(this.disableonstatus || !this.isDatabookExist)) {
      this.router.navigate(["/engagement", this.engagement.Id, "databook"]);
    }
  }

  addEditAdjustment() {
    if (
      !(
        this.disableonstatus ||
        (!this.isDatabookExist && !this.engagement.IsDatabookFinished)
      )
    ) {
      if (this.isDatabookExist) {
        this.router.navigate([
          "/engagement",
          this.engagement.Id,
          "uploaddatabook",
        ]);
      } else {
        this.router.navigate([
          "/engagement",
          this.engagement.Id,
          "selectadjustment",
        ]);
      }
    }
  }

  public downloadActvityDetailsExcel() {
    event.stopPropagation();
    this.loadspinner = true;
    this.auditingService.getActvityDetailsExcel(this.engagement.Id).subscribe(
      (blobData) => {
        this.loadspinner = false;
        if (blobData) {
          saveAs(
            blobData,
            this.engagement.EngagementName + "_AuditLog" + ".xlsx"
          );
          this.messageService.add({
            key: this.currLangTranslation.severitymessage.key,
            severity: severitymessage.success,
            summary: this.currLangTranslation.severitymessage.notification,
            detail:
              this.currLangTranslation.severitymessage.AuditLogReportDownloaded,
            sticky: true,
            closable: true,
          });
        } else {
          this.messageService.add({
            key: this.currLangTranslation.severitymessage.key,
            severity: severitymessage.error,
            summary: this.currLangTranslation.severitymessage.notification,
            detail: this.currLangTranslation.severitymessage.somethingwrong,
            sticky: true,
            closable: true,
          });
        }
      },
      (err) => {
        this.loadspinner = false;
        this.messageService.add({
          key: this.currLangTranslation.severitymessage.key,
          severity: severitymessage.error,
          summary: this.currLangTranslation.severitymessage.notification,
          detail: this.currLangTranslation.severitymessage.somethingwrong,
          sticky: true,
          closable: true,
        });
      }
    );
  }

  getUploadedSourceFiles() {

    this.engagementService.getUploadedSourceFiles(this.engId).subscribe(
      (response: any) => {

        if(response.length == 0){
        this.isAssessmentDisabled = true;
        }
      }
    )
  }
}





